import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import Loading from "../../../components/Loading";
import PaginateCard from "../../../components/PaginateCard";
import { getRequestByAuth } from "../../../function/helper";
import useFilters from "../../../hooks/useFilters";
import OrderDetailsModal from "./digikalaOrders/OrderDetailsModal";
import OrdersTable from "./digikalaOrders/OrdersTable";

export default function DigikalaOrders({ getSellerData }) {
  const filters = useFilters({ page: 1, items: 20 });

  const { isFetching, data, refetch } = useQuery({
    queryKey: ["getDigikalaShipBySeller"],
    queryFn: () =>
      getRequestByAuth(
        "/v2/digikala/getDigikalaShipBySeller",
        filters.getAll()
      ).then(res => {
        if (res && res.status === 200) {
          return res?.data || {};
        }
        return {};
      }),
    retry: 0,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  const items = data?.items || [];
  const [selectedOrder, setSelectedOrder] = useState(null);

  async function onOpenDetails(order) {
    setSelectedOrder(order);
  }

  return (
    <>
      {isFetching && <Loading className="h-25" />}

      {!isFetching && (
        <div className="mb-2 rtl w-100">
          <div className="bg-white shadow rounded px-4 py-3 w-100">
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
              <h5 className="text-dark pt-2 mb-3">لیست سفارشات دیجی‌کالا</h5>
            </div>

            <div className="pt-2 w-100">
              <OrdersTable
                filters={filters}
                items={items}
                onOpenDetails={onOpenDetails}
                refetch={refetch}
              />
            </div>

            <div className="py-3">
              <PaginateCard
                count={data?.pager?.total_rows || 0}
                numberItems={filters.get("items")}
                numberPage={filters.get("page")}
                onIndexChoose={page => {
                  filters.set("page", page);
                  refetch();
                  window.scrollTo({ behavior: "smooth", top: 50 });
                }}
              />
            </div>
          </div>
        </div>
      )}

      {selectedOrder && (
        <OrderDetailsModal
          getSellerData={getSellerData}
          order={selectedOrder}
          onClose={() => setSelectedOrder(null)}
          refetch={refetch}
        />
      )}
    </>
  );
}
